import type { ImageAsset } from '@/assets';
import { strings } from '@/content/strings';
import { Frame } from './Frame';
import { Surface } from './Surface';
import styles from './ChoiceCards.module.css';

export interface ChoiceOption {
  id: string;
  word: string;
  picture: ImageAsset;
}

interface ChoiceCardsProps {
  options: readonly ChoiceOption[];
  /** The child tapped a card (saying the word chooses it too). */
  onChoose: (id: string) => void;
}

/**
 * The child picks the next word (learner choice, coaching-framework.md principle 5): two picture
 * cards in the word card's place. Saying one chooses it and counts as its first try; tapping
 * works as well.
 */
export function ChoiceCards({ options, onChoose }: ChoiceCardsProps) {
  return (
    <Frame className={styles.frame}>
      <Surface variant="glassPanel" className={styles.panel} aria-label={strings.speech.chooseNext}>
        <div className={styles.cards}>
          {options.map((o) => (
            <button
              key={o.id}
              type="button"
              className={styles.card}
              onClick={() => {
                onChoose(o.id);
              }}
            >
              <span className={styles.picture}>
                <img
                  src={o.picture.url}
                  width={o.picture.width}
                  height={o.picture.height}
                  alt=""
                  draggable={false}
                />
              </span>
              <span className={styles.word}>{o.word}</span>
            </button>
          ))}
        </div>
      </Surface>
    </Frame>
  );
}
